<template>
  <div>
    <transition v-if="message && !is_closed" name="fade">
      <div class="notification m-1" :class="notification_class" style="z-index: 0">
        <button class="delete" @click="close"></button>
        <span v-html="message"></span>
      </div>
    </transition>
  </div>
</template>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>

<script>
export default {
  name: 'AnnouncementMessage',
  props: {
    uuid: { type: String, default: '' },
    message: { type: String, default: '' },
    notification_class: { type: String, default: 'is-primary' }
  },
  data() {
    const is_closed = window.localStorage.getItem('announcement-message-closed-' + this.uuid);
    return {
      is_closed: is_closed ? true : false
    };
  },
  methods: {
    close() {
      this.is_closed = true;
      window.localStorage.setItem('announcement-message-closed-' + this.uuid, 1);
    }
  }
};
</script>
